import React from 'react'
import { useHistory } from 'react-router-dom'

import { Button, Modal, ModalInjectedProps } from '@sketch/components'
import { routes } from '@sketch/modules-common'

interface UserOwnsWorkspacesModalProps extends ModalInjectedProps {
  workspaceIdentifier: string
}

/**
 * Modal displayed when a user tries to delete their account but still owns workspaces.
 * They need to transfer or delete these workspaces before proceeding with account deletion.
 */
const UserOwnsWorkspacesModal = ({
  hideModal,
  workspaceIdentifier,
}: UserOwnsWorkspacesModalProps) => {
  const history = useHistory()

  const handleGoToWorkspaceSettings = () => {
    if (hideModal) {
      hideModal()
    }

    // Navigate to the workspace settings page
    const workspaceSettingsPath = routes.WORKSPACE_SETTINGS_SETTINGS.create({
      workspaceId: workspaceIdentifier,
    })
    history.push(workspaceSettingsPath)
  }

  return (
    <Modal title="Just one thing first…" onCancel={hideModal}>
      <Modal.Body>
        <p>
          Before you can delete your account, you need to transfer or delete any
          Workspaces that belong to you.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleGoToWorkspaceSettings}>
          Go to Workspace Settings
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UserOwnsWorkspacesModal
